import Vue from 'vue'
import router from '@/router'
import appMenu from '@/_nav'
import { authNav } from '@/shared/auth/temAcesso'

const state = {
    token: null,
    expirationDate: null,
    usuario: {
        usuarioId: null,
        nome: null,
        email: null,
        login: null,
        aspl: null,
        tipo: null,
        chapa: null,
        ultimoAcesso: null
    },
    fornecedor: {
        fornecedorId: null,
        cpfCnpj: null,
        razaoSocial: null
    },
    menu: []
}

const mutations = {
    SET_USUARIO(state, auth) {
        let decodedToken = Vue.$jwt.decode(auth.token)
        state.token = auth.token
        state.usuario.usuarioId = decodedToken.usrId
        state.usuario.nome = decodedToken.usrName
        state.usuario.login = decodedToken.usrLogin
        state.usuario.email = decodedToken.usrEmail
        state.usuario.aspl = decodedToken.usrAsplFlag
        state.usuario.tipo = decodedToken.usrType
        state.usuario.chapa = decodedToken.usrChapa
        state.usuario.ultimoAcesso = decodedToken.usrUltimoAcesso
        if (decodedToken.usrFornecedorId) {
            state.fornecedor = {
                fornecedorId: decodedToken.usrFornecedorId,
                cpfCnpj: decodedToken.usrFornecedorCpfCnpj,
                razaoSocial: decodedToken.usrFornecedorRazaoSocial
            }
        }
        state.expirationDate = auth.time
    },

    REMOVE_USUARIO(state) {
        let usrTipo = state.usuario.tipo
        state.token = null
        state.expirationDate = null
        state.usuario.usuarioId = null
        state.usuario.nome = null
        state.usuario.login = null
        state.usuario.email = null
        state.usuario.aspl = null
        state.usuario.tipo = null
        state.usuario.chapa = null
        state.usuario.ultimoAcesso = null
        state.fornecedor = {
            fornecedorId: null,
            cpfCnpj: null,
            razaoSocial: null
        }
        localStorage.removeItem('token')
        localStorage.removeItem('userId')
        localStorage.removeItem('expirationDate')
        if (usrTipo == 'e') {
            router.push('/login')
        } else {
            router.push('/login/interno')
        }
    },

    ATUALIZAR_MENU(state) {
        state.menu = authNav(appMenu.items)
    }
}

const actions = {
    login({ commit, dispatch, state }, authData) {
        let tFim = new Date(authData.expiraEm)
        let tInicio = new Date(authData.criadoEm)
        let tempoExpirar = tFim.getTime() - tInicio.getTime()
        let agora = Vue.moment(new Date())
        let localExpiraEm = agora.add(tempoExpirar, 'ms')
        commit('SET_USUARIO', {
            token: authData.accessToken,
            time: localExpiraEm
        })
        localStorage.setItem('token', authData.accessToken)
        localStorage.setItem('localExpirationDate', localExpiraEm)
        dispatch('atualizarMenu')
    },

    logout({ commit }) {
        commit('REMOVE_USUARIO')
    },

    tryAutoLogin({ commit, dispatch }) {
        const token = localStorage.getItem('token')
        if (!token) {
            return
        }
        const expirationDate = new Date(
            localStorage.getItem('localExpirationDate')
        )
        const now = new Date()
        if (now >= expirationDate) {
            commit('REMOVE_USUARIO')
            return
        }
        commit('SET_USUARIO', {
            token: token,
            time: expirationDate
        })
        dispatch('atualizarMenu')
    },

    atualizarMenu({ commit }) {
        commit('ATUALIZAR_MENU')
    }
}

const getters = {
    usuario(state) {
        return state.usuario
    },

    fornecedor(state) {
        return state.fornecedor
    },

    estaAutenticado(state) {
        if (state.usuario.aspl === 'True') {
            router.push('/atualizarsenha')
        }
        return state.token !== null
    },

    getToken(state) {
        return state.token
    },

    menu(state) {
        return state.menu
    },

    getExpirationDate(state) {
        return state.expirationDate
    },

    isFornecedor(state) {
        return state.fornecedor.fornecedorId != null
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}
